export const schoolAreaRecord: Record<string, string> = {
  'JY_CHENGXI':  '澄西片',
  'JY_QINGYANG':  '青阳片',
  'JY_HUASHI': '华士片',
  'JY_CHANGJING': '长泾片',
  'JY_CHENGYAO': '澄要片',
  'JY_ZHISHU': '直属',
  'JY_OTHERS': '其它',
  'JY_CHENGJIANG1': '澄江街道（1）',
  'JY_CHENGJIANG2': '澄江街道（2）',
  'JY_YAOSAI': '原要塞片',
  'JY_CHENGNAN': '澄南片',
  'JY_CHENGDONG': '澄东片',
  'JY_CHENGDONGNAN': '澄东南片'
};

export const schoolAreaSeq: Record<string, number> = {
  'JY_CHENGXI':  4,
  'JY_QINGYANG':  10,
  'JY_HUASHI': 9,
  'JY_CHANGJING': 11,
  'JY_CHENGYAO': 8,
  'JY_ZHISHU': 12,
  'JY_OTHERS': 13,
  'JY_CHENGJIANG1': 1,
  'JY_CHENGJIANG2': 2,
  'JY_YAOSAI': 3,
  'JY_CHENGNAN': 5,
  'JY_CHENGDONG': 6,
  'JY_CHENGDONGNAN': 7
};

export const groupRecord: Record<string, string> = {
  'JY_NANJING': '南菁集团',
  'JY_SHIZHONG': '市中集团',
  'JY_YIZHONG': '一中集团',
  'JY_YUSHANWAN': '敔山湾集团',
  'JY_ZHOUZHUANG': '周庄集团',
  'JY_QINGYANG': '青阳集团',
  'JY_HUASHI': '华士集团'
};

export const townRecord: Record<string, string> = {
  'JY_ZHISHU': '直属',
  'JY_XIAGANG': '夏港',
  'JY_CHENGDONG': '城东',
  'JY_ZHUTANG': '祝塘',
  'JY_ZHOUZHUANG': '周庄',
  'JY_HUANGTU': '璜土',
  'JY_GUSHAN': '顾山',
  'JY_CHANGJING': '长泾',
  'JY_YUNTING': '云亭',
  'JY_LIGANG': '利港',
  'JY_XUXIAKE': '徐霞客',
  'JY_NANZHA': '南闸',
  'JY_XINQIAO': '新桥',
  'JY_QINGYANG': '青阳',
  'JY_HUASHI': '华士',
  'JY_SHENGANG': '申港',
  'JY_YUECHENG': '月城'
};
export const townSeq: Record<string, number> = {
  'JY_ZHISHU': 1,
  'JY_XIAGANG': 2,
  'JY_CHENGDONG': 3,
  'JY_ZHUTANG': 4,
  'JY_ZHOUZHUANG': 5,
  'JY_HUANGTU': 6,
  'JY_GUSHAN': 7,
  'JY_CHANGJING': 8,
  'JY_YUNTING': 9,
  'JY_LIGANG': 10,
  'JY_XUXIAKE': 11,
  'JY_NANZHA': 12,
  'JY_XINQIAO': 13,
  'JY_QINGYANG': 14,
  'JY_HUASHI': 15,
  'JY_SHENGANG': 16,
  'JY_YUECHENG': 17
};


export const courseRecord: Record<string, string> = {
  'CHINESE' :'语文',
  'MATH':	'数学',
  'MATH_ADDITIONAL': '数学附加',
  'ENGLISH': '英语',
  'PHYSICS': '物理',
  'CHEMISTRY': '化学',
  'HISTORY': '历史',
  'MORALITY_RULE_OF_LAW':'道德与法治',
  'POLITICS': '政治',
  'GEOGRAPHY': '地理',
  'BIOLOGY': '生物',
  'SCIENCE': '科学',
  'MUSIC': '音乐',
  'ART': '美术',
  'SPORTS':	'体育',
  'INFORMATION_TECHNOLOGY':	'信息技术',
  // 'COMPREHENSIVE_SCIENCE': '理科综合',
  // 'COMPREHENSIVE_LIBERAL_ARTS':	'文科综合',
  'GENERAL_TECHNOLOGY': '通用技术'
  // 'COMPREHENSIVE': '综合',
  // 'JAPANESE':	'日语',
  // 'PSYCHOLOGY':	'心理',
  // 'CRAFT': '艺术',
  // 'OTHERS': '其他'
};
export const courseRecordOrder: Record<string, number> = {
  'CHINESE' : 1,
  'MATH':	2,
  'MATH_ADDITIONAL': 2,
  'ENGLISH': 3,
  'PHYSICS': 4,
  'CHEMISTRY': 5,
  'HISTORY': 6,
  'MORALITY_RULE_OF_LAW':7,
  'POLITICS': 8,
  'GEOGRAPHY': 9,
  'BIOLOGY': 10,
  'SCIENCE': 11,
  'MUSIC': 12,
  'ART': 13,
  'SPORTS':	14,
  'INFORMATION_TECHNOLOGY':	15,
  // 'COMPREHENSIVE_SCIENCE': '理科综合',
  // 'COMPREHENSIVE_LIBERAL_ARTS':	'文科综合',
  'GENERAL_TECHNOLOGY': 16
  // 'COMPREHENSIVE': '综合',
  // 'JAPANESE':	'日语',
  // 'PSYCHOLOGY':	'心理',
  // 'CRAFT': '艺术',
  // 'OTHERS': '其他'
};

export const courseOtherRecord: Record<string, string> = {
  'CHINESE_COMPOSITION': '语作',
  'CHINESE_REGULAR': '语基',
  'ENGLISH_ORAL': '英口',
  'ENGLISH_REGULAR': '英基'
};

// 学段
export const schoolGradeRecord: Record<string, string> = {
  // 'K': '幼儿园',
  'P': '小学',
  'J': '初级中学',
  'S': '高级中学',
  'PJ': '九年一贯制',
  'JS': '完全中学',
  'PJS': '小初高'
};


export const gradeRecord: Record<string, string> = {
  // 'K0': '小小班',
  // 'K1':	'小班',
  // 'K2':	'中班',
  // 'K3':	'大班',
  'P1':	'一年级',
  'P2':	'二年级',
  'P3':	'三年级',
  'P4':	'四年级',
  'P5':	'五年级',
  'P6':	'六年级',
  'J1':	'初一',
  'J2':	'初二',
  'J3':	'初三',
  'S1':	'高一',
  'S2':	'高二',
  'S3':	'高三'
};

export const studentTypeRecord: Record<string, string> = {
  'NORMAL': '普通学生',
  'SICK': '病假',
  'AFFAIRS': '事假',
  'SUSPEND': '休学',
  'OTHERS': '其他',
  'SPORTS': '体育生1',
  'SPORTS2': '体育生2',
  'INCLUSIVE': '融通教育1',
  'INCLUSIVE2': '融通教育2',
  'LEAVE': '辍学'
};

export const templateRateTypeRecord: Record<string, string> = {
  'FULL_SCORE_RATE': '按满分百分比',
  'SCORE': '按分数线',
  'DEPENDONFULL100': '按满分大小'
};

export const TemplateFourRatesTypeRecord: Record<string, string> = {
  'EXCELLENT': '优秀率',
  'GOOD': '良好率',
  'PASS': '合格率',
  'LOWSCORE': '低分率'
};

export const TemplatePrimaryRecord: Record<string, string> = {
  'EXCELLENT': '优秀',
  'GOOD': '良好',
  'PASS': '合格'
};

export const markTypeRecord: Record<string, string> = {
  'M2_LIMITPASS': '及格分*2统计',
  'ASZERO': '计0分统计',
  'EXCLUDE': '计分不统计',
  'NONE': '按缺考规则计算'
};

export const studentMarkTypeRecord: Record<string, string> = {
  'SICK': '病假',
  'AFFAIRS': '事假',
  'SUSPEND': '休学',
  'OTHERS': '其他',
  'SPORTS': '体育生1',
  'SPORTS2': '体育生2',
  'INCLUSIVE': '融通教育1',
  'INCLUSIVE2': '融通教育2',
  'LEAVE': '辍学'
};

export const applyMarkReviewRecord: Record<string, string> = {
  'WAITREVIEW': '待审核',
  'PASS': '审核通过',
  'NOPASS': '审核不通过',
  'CANCEL': '已撤回'
};

/**
 * @description 根据学校学段获取学校年级
 * @param type 学段
 * @returns 年级Map
 */
export const getGradeBySchoolType = (type: string) => {
  const arr = type.split('');
  const o: Record<string, string> = {};
  arr.forEach(a => {
    Object.entries(gradeRecord).forEach(([key, value]) => {
      if (key.includes(a)) {
        o[key] = value;
      }
    });
  });
  return o;
};

/**
 * 根据年级获取当前学段的学科
 */

export const getCourseByGrade = (g: string) => {
  if (
    g === ''
  ) return Object.keys(courseRecord);
  let list: string[] = [];
  if (g.includes('P')) {
    // 小学
    list = [
      ...list,
      'CHINESE',
      'MATH',
      'MATH_ADDITIONAL',
      'ENGLISH',
      'MORALITY_RULE_OF_LAW',
      'SCIENCE',
      'MUSIC',
      'ART'
    ];
  }
  if (g.includes('J')) {
    // 初中
    list = [
      ...list,
      'CHINESE',
      'MATH',
      'MATH_ADDITIONAL',
      'ENGLISH',
      'PHYSICS',
      'CHEMISTRY',
      'HISTORY',
      'MORALITY_RULE_OF_LAW',
      'GEOGRAPHY',
      'BIOLOGY',
      'MUSIC',
      'ART',
      'SPORTS',
      'INFORMATION_TECHNOLOGY'
    ];
  }
  if (g.includes('S')) {
    // 高中
    list = [
      ...list,
      'CHINESE',
      'MATH',
      'ENGLISH',
      'PHYSICS',
      'CHEMISTRY',
      'HISTORY',
      'POLITICS',
      'GEOGRAPHY',
      'BIOLOGY',
      'MUSIC',
      'ART',
      'SPORTS',
      'INFORMATION_TECHNOLOGY',
      'GENERAL_TECHNOLOGY'
    ];
  }
  return Array.from(new Set(list)).sort((a, b) => courseRecordOrder[a] - courseRecordOrder[b]);
};
